var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.581,
    height: 71.004,
    viewBox: "0 0 87.581 71.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.5 -11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 11.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.472,43.164a1.937,1.937,0,0,0-2.394,0L29.028,56.15a1.981,1.981,0,0,0,2.3,3.223l1.658-1.2V73.095a2.044,2.044,0,0,0,2.026,2.026H61.352a2.044,2.044,0,0,0,2.026-2.026V58.176l1.658,1.2a1.851,1.851,0,0,0,1.2.368,2.092,2.092,0,0,0,1.658-.829,1.943,1.943,0,0,0-.46-2.763Zm.829,27.9H46.157V62.5H50.3Zm9.117,0H54.353V60.478a2.044,2.044,0,0,0-2.026-2.026h-8.1A2.044,2.044,0,0,0,42.2,60.478V71.069H37.132V55.321l11.143-8.1,11.143,8.1Z",
    transform: "translate(-4.531 -13.971)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.608,11.5H10.88A8.411,8.411,0,0,0,2.5,19.88V74.123a8.411,8.411,0,0,0,8.38,8.38H81.7a8.411,8.411,0,0,0,8.38-8.38V19.88A8.551,8.551,0,0,0,81.608,11.5ZM10.88,15.828H81.7a4.088,4.088,0,0,1,4.052,4.052V30.471H6.828V19.88A4.029,4.029,0,0,1,10.88,15.828ZM81.608,78.083H10.88a4.088,4.088,0,0,1-4.052-4.052V34.8H85.66V74.031A4.029,4.029,0,0,1,81.608,78.083Z",
    transform: "translate(-2.5 -11.5)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(9.486 8.473)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(18.879 8.473)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(28.273 8.473)",
    fill: "#121e59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.862ecf73c0bddc7df53df0ccfe3a3c56.svg";
export { ForwardRef as ReactComponent };